export default __webpack_public_path__ + "static/media/exposure_l.bc9f25cd.jpg";